import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IntegerControl } from '../../../controls/setup-wizard/integer-control/integer-control';

@Component({
	selector: 'app-integer-field',
	standalone: true,
	imports: [IntegerControl],
	templateUrl: './integer-field.html',
})
export class IntegerField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	min = input<number | null>(null);
	max = input<number | null>(null);
	formGroup = input.required<FormGroup>();
	disabled = input<boolean>(false);
}
